<template>
  <div v-if="courses.length > 0">
    <h2 class="section-title m-4 text-center text-lg">
      {{ $t('model_cource_title') }}
    </h2>
    <div id="courseList">
      <ul class="courselist pl-4">
        <li v-for="course in courses" :key="course.id">
          <div class="course">
            <div class="course-info">
              <h3 class="course-title">
                {{ course.title }}
              </h3>
              <img v-lazy="course.image" class="course-image" />
              <p class="course-detail" v-html="course.detail"></p>
            </div>
            <div class="course-button m-4">
              <a class="button-primary block" v-on:click="showModal(course)">
                {{ $t('display_detail_label') }}
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <CourseModal v-show="modal.show" :closeModal="() => closeModal()">
      <CourseDetail :course="course" @createItem="createItem" />
    </CourseModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CourseModal from "../molecules/CourseModal"
import CourseDetail from '../molecules/CourseDetail'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  name: 'CourseList',
  components: {
    CourseModal,
    CourseDetail
  },
  data () {
    return {
      course: {},
      modal: {
        show: false
      }
    }
  },
  mounted () {
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('courses/fetchAll')
      .then(() => {
        this.$store.dispatch('loading/endLoading')
      })
  },
  methods: {
    showModal (course) {
      this.course = course
      this.modal.show = true
    },
    closeModal () {
      this.modal.show = false
    },
    createItem (courseId) {
      // GoogleAnalytics
      this.$gtag.event("コースからプラン作成", {
        course_name: this.course.title,
        date_time: moment().format("YYYY/MM/DD HH:mm:ss"),
        token: this.$store.getters['user/getToken']
      });
      if (this.$store.getters['user/getToken'] !== null) {
        if (this.$store.getters['user/getProfile'] !== null) {
          this.$router.push({ name: 'newPlan', params: { courseId: courseId } })
        } else {
          this.$emit('openPlanSetting')
        }
      } else {
        this.$emit('openPlanTerms')
      }
    }
  },
  computed: {
    ...mapGetters({
      courses: 'courses/getAll'
    })
  }
}
</script>
